import React from "react";
import {
  Button,
  Iconography,
  IconographySizes,
} from "@hid-galaxy-ui/galaxy-react";

interface RolesHeaderProps {
  onAddNewRole: () => void;
  readOnly?: boolean;
}

const RolesHeader: React.FC<RolesHeaderProps> = ({ onAddNewRole, readOnly = false }) => {
  return (
    <div className="rp-header">
      <div className="rp-header__content">
        <h2>User management</h2>
        <p>Configure access levels and permission sets</p>
      </div>
      <Button
        variant="primary"
        label="Add New Role"
        icon={<Iconography icon="plus" size={IconographySizes.Medium} />}
        onClick={onAddNewRole}
        disabled={readOnly}
      />
    </div>
  );
};

export default RolesHeader;
